export default "__VITE_ASSET__BvdYXxWv__"